<template>

    <div class="response-to-action">
        <div class="check">
            <em class="far fa-check"/>
        </div>
        <h2>Obrigado por entrar em contato conosco</h2>
        <p>Sua mensagem foi enviada com sucesso e nossa equipe entrará em contato com você em breve.</p>
        <ui-button design="md line-primary" @click="backForm">Enviar nova mensagem</ui-button>
    </div>

</template>

<script>

import { uiButton } from '@/components/ui/buttons'

export default {
    name: 'ui-success-alert',
    components: {
        uiButton,
    },
    methods:{
        backForm(){
           this.$emit('input', false)
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>